import { Button, Link, Stack, Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import { Dialogs, useDialogs } from '../../Contexts/DialogsContext'
import BaseDialog from '../Common/BaseDialog'
import SignIn from './SignIn'
import SignUp from './SignUp'

const JoinUs: React.FC = () => {
    const { registerDialog, unregisterDialog } = useDialogs()

    const onOpenOtherDialog = (dialogName: Dialogs, component: ReactNode) => {
        unregisterDialog(Dialogs.JOIN_US)
        registerDialog(dialogName, component)
    }

    return (
        <BaseDialog name={Dialogs.JOIN_US} title="Join Us!" horizontalCentered forceBlock>
            <Typography variant="h5" textTransform="uppercase">
                Sign up to access this feature
            </Typography>
            <Typography variant="body1">
                Becoming an ICC member is FREE, and registering is faster than delivering a checkmate with two rooks!
            </Typography>
            <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
                <Typography variant="body1">Already have an account?</Typography>
                <Link variant="body1" onClick={() => onOpenOtherDialog(Dialogs.SIGNIN, <SignIn />)}>
                    Log in
                </Link>
            </Stack>
            <Typography>Or</Typography>
            <Link variant="body1" onClick={() => unregisterDialog(Dialogs.JOIN_US)}>
                Continue As A Guest
            </Link>
            <Button
                size="large"
                fullWidth
                variant="contained"
                onClick={() => onOpenOtherDialog(Dialogs.SIGNUP, <SignUp />)}
            >
                Sign Up
            </Button>
            <Typography variant="body2" color="text.disabled" textTransform="capitalize">
                P.S. Signing up takes 60 seconds or less
            </Typography>
        </BaseDialog>
    )
}

export default JoinUs
